module.exports = __webpack_public_path__ + "img/pic__photo_06@2x.4e8ae15a.png";